import { render, staticRenderFns } from "./EditBasicInfoForm.vue?vue&type=template&id=0cfac594&scoped=true&"
import script from "./EditBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./EditBasicInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./EditBasicInfoForm.vue?vue&type=style&index=0&id=0cfac594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfac594",
  null
  
)

export default component.exports